import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, ResolveFn } from "@angular/router";
import { AppService } from "../app.service";

export const OrgnizationResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const appService = inject(AppService);

  return appService.getOneQmsOrganization();
};
